import { IAppState } from '../../redux';
import { EServiceId } from '../../redux/reducers';
import { selectIsPromotionPackageSelected, selectActiveServiceId } from '../publishTerms';
import { selectIsAuctionEnabled } from './selectIsAuctionEnabled';

export function selectIsAuctionSelected(state: IAppState): boolean {
  const isAuctionEnabled = selectIsAuctionEnabled(state);

  const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);

  const activeServiceId = selectActiveServiceId(state);

  // Для аукциона в топовой ФВУ нужно быть в эксперименте MONEY-440 и размещаться не из пакета продвижения
  // Ставка из аукциона в топовой ФВУ доступна только для топа
  const isAuctionForServiceEnabled = activeServiceId === EServiceId.top;

  return isAuctionEnabled && (isPromotionPackageSelected || isAuctionForServiceEnabled);
}
